<template>
  <b-row style="background-color: #e4e6eb;
         border-radius: 15px;
          padding:15px; margin:3px;">
    <b-col>
      <b-row>
        <b-col cols="3">
          <b-avatar
              variant="warning"
              :src="crewMember.imgURL"
              size="3em"
          />
        </b-col>
        <b-col cols="9">
          <b-row>
            <b-col>
              <p class="mb-1">{{crewMember.name}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p class="mb-1">{{ crewMember.position }}</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="margin-top: 10px">
        <b-col>
          <toggle-single id="host"
                         label-name="Host"
                         :toggle-model="crewMember.role.isHost"
                         @toggle-click="handleToggleClick"
          />
        </b-col>
        <b-col>
          <toggle-single id="speaker"
                         label-name="Speaker"
                         :toggle-model="crewMember.role.isSpeaker"
          />
        </b-col>
        <b-col>
          <toggle-single id="admin"
                         label-name="Admin"
                         :toggle-model="crewMember.role.isAdmin"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import ToggleSingle from "@/components/common/toggleSingle";
export default {
  name: "AddEditSession_Crew_Member_Row",
  components: {
    ToggleSingle
  },
  props: {
    crewMember: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
  },
  methods: {
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    },
    handleToggleClick({idx, key}) {

     // this.form.crew[idx].role[key]= !this.form.crew[idx].role[key];
    },
    input(val) {
      this.handleValueChange('agenda', val.content);
    },
    resetClear() {
      this.clear = false;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>

</style>

